/**
 * @deprecated Route constants are now defined in documents.service.machine.ts
 * These exports are maintained for backward compatibility with routes.ts
 */
export const DOCUMENTS_ROUTES = {
  get: '/documents/with-results',
  post: '/documents',
  patch: '/documents/{id}',
  delete: '/documents/{id}',
};

export const DOCUMENT_DOWNLOAD_ROUTES = {
  get: '/documents/{id}/content',
};

export const DOCUMENT_CV_UPLOAD_ROUTES = {
  post: '/documents/cv-parse',
};

export const AI_JOBS_ROUTES = {
  get: '/ai-jobs/{provider_id}/with-results',
  patch: '/documents/parse/{id}',
};
